<template>
  <div>
    <veaDialog
      :title="choos.name"
      class="image_import_dialog"
      :show.sync="show"
      :showBtn="false"
      :before-close="closeDialog"
    >
      <el-row :gutter="10">
        <el-col :span="6" v-for="(item, idx) in filelist" :key="idx">
          <el-card
            shadow="always"
            class="proitem"
            :class="{ isactive: co.id == item.id }"
            :body-style="{ padding: '0px' }"
          >
            <a @click="choose(item)">
              <div class="image">
                <img
                  :src="getPic(item)"
                  :alt="item.sfilename"
                  :class="{
                    pic:
                      ['.jpg', '.png', '.jpeg', '.gif'].indexOf(
                        item.fileext.toLowerCase()
                      ) > -1
                  }"
                />
              </div>

              <div class="name">
                {{ item.sfilename }}
              </div>
            </a>
          </el-card>
        </el-col>
      </el-row>

      <template slot="footer-left">
        <file
          ref="choos"
          :choos="choos"
          :fileselectData="[co]"
          :ty="ty"
          :pautoid="pautoid"
          @GetFile="_GetFile()"
        />
      </template>
    </veaDialog>
  </div>
</template>

<script>
import { GetFile } from '@api/api.js'
import file from '@components/file.vue'
export default {
  components: { file },
  props: {
    pautoid: {
      // 传入的autoid
      type: String,
      default: ''
    },
    choos: {
      // 选中的附件类型
      type: Object,
      default: () => {}
    },
    ty: {
      // 是否通用模板
      type: [Number, String],
      default: '0'
    }
  },
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.userInfo) || {}, // 用户登录信息
      name: '',
      autoid: 0,
      show: false,
      filelist: [],
      co: { id: 0 },
      doc: require('@assets/img/word.png'), // 图标word
      xls: require('@assets/img/excel2.png'), // 图标excel
      ppt: require('@assets/img/ppt2.png'), // 图标ppt
      pdf: require('@assets/img/pdf.svg'),
      pic: require('@assets/img/picture.png'), // 图标jpg
      zip: require('@assets/img/zip.png'), // 图标zip
      defaultSrc: require('@/assets/img/defaultSrc.png'), // 默认
      xmind: require('@assets/img/xmind.png'), // 图标xmind
      video: require('@assets/img/video.svg') // 图标video
    }
  },
  watch: {
    show(val) {
      if (val) {
        this.name = this.$route.query.name
        this.autoid = this.$route.query.autoid
        this._GetFile()
      }
    }
  },
  methods: {
    _GetFile() {
      GetFile({
        autoid: this.pautoid || this.autoid,
        packagetype: this.choos.name
      }).then(res => {
        this.filelist = res.list.filter(e => {
          return e.ty == this.ty && this.choos.name == e.packagetype
        })
      })
    },
    getPic(item) {
      let r = ''
      if (
        ['.jpg', '.png', '.jpeg', '.gif'].indexOf(item.fileext.toLowerCase()) >
        -1
      ) {
        // 图片类型
        r = item.imgurl
      } else {
        let name = ''
        let type = ''
        const ext = item.fileext
          .slice(1)
          .toString()
          .toLowerCase() // 后缀
        if ('doc|docx'.includes(ext)) {
          name = 'WORD文件'
          type = 'doc'
        } else if ('xlsx|xls'.includes(ext)) {
          name = 'EXCEL文件'
          type = 'xls'
        } else if ('ppt|pptx'.includes(ext)) {
          name = 'PPT文件'
          type = 'ppt'
        } else if ('pdf'.includes(ext)) {
          name = 'PDF文件'
          type = 'pdf'
        } else if ('png|jpg|jpeg|emp'.includes(ext)) {
          name = '图片文件'
          type = 'pic'
        } else if ('zip|rar'.includes(ext)) {
          name = '压缩文件'
          type = 'zip'
        } else if ('wmv|asf|asx|rm|rmvb|mp4|3gp|mov|m4v'.includes(ext)) {
          name = '视频文件'
          type = 'video'
        } else {
          name = '其他文件'
          type = 'default'
        }
        r = this.getImg(type)
      }
      return r
    },
    // 获取照片
    getImg(type) {
      if (type === 'doc') {
        return this.doc
      } else if (type === 'xls') {
        return this.xls
      } else if (type === 'ppt') {
        return this.ppt
      } else if (type === 'pdf') {
        return this.pdf
      } else if (type === 'pic') {
        return this.pic
      } else if (type === 'zip') {
        return this.zip
      } else if (type === 'video') {
        return this.video
      } else if (type === 'default') {
        return this.defaultSrc
      }
    },
    choose(e) {
      this.co = e
    },
    // 右上角 关闭按钮 点击事件
    closeDialog() {
      this.show = false
      this.$emit('GetFile')
    }
  }
}
</script>

<style scoped lang="scss">
@import '~@/styles/mixin.scss';
.el-dialog__wrapper.image_import_dialog {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(1200px, 700px);

    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
    .el-dialog__body {
      padding: 20px 20px 0 20px;
      // flex: 1;
      overflow: auto;
      .el-card {
        height: 180px;
        margin: 10px 0;
        cursor: pointer;
        border: 1px solid transparent;
        .image {
          width: 100%;
          height: 120px;
          display: flex;
          align-items: center;
          overflow: hidden;
          justify-content: center;
          img {
            width: 100px;
          }
          img.pic {
            width: 100%;
          }
        }
        .name {
          font-size: 16px;
          font-weight: 500;
          padding: 10px;
        }
      }
      .el-card.isactive {
        border: 1px solid #0082f5;
      }
    }
  }
}
</style>
